import { FormEvent } from 'react';

export const sortingOptions = (t: Function) => [
  { label: t('sort.default', { ns: 'common' }), value: '' },
  { label: t('sort.device-id', { ns: 'common' }), value: 'device_id' },
];

export interface SelectOption {
  label: string;
  id: string;
  value: string;
}

export enum DialogType {
  Add = 'Add',
  Edit = 'Edit',
  Delete = 'Delete',
}

export interface DialogConfig {
  title: string;
  subtitle?: string;
  note?: string;
  fields: DialogField[];
}

export interface DialogField {
  label: string;
  type?: string;
  name: string;
  value?: string;
  isRequired?: boolean;
  readOnly?: boolean;
  options?: SelectOption[];
}

export interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  handleSubmit: (
    e: FormEvent<Element>,
    newData: NewDataField & { id: string }
  ) => Promise<void>;
  title: string;
  subtitle: string;
  note?: string;
  fields: DialogField[];
  deviceId?: string;
  attendanceId?: string;
  vehicleId?: string;
  taskSessionId?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export interface NewDataField {
  id: string;
  [key: string]: string | number | null;
}

export const createTextField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'text',
  name,
  isRequired,
  value,
  readOnly,
});

export const createSelectField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'select',
  name,
  isRequired,
  value,
  readOnly,
});

export const createDateField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'date',
  name,
  isRequired,
  value,
  readOnly,
});

export const createTimeField = (
  label: string,
  name: string,
  isRequired: boolean,
  value: string,
  readOnly?: boolean
): DialogField => ({
  label,
  type: 'time',
  name,
  isRequired,
  value,
  readOnly,
});
